const mutations = {
  // page title
  setPageTitle: function(state, title) {
    state.pageTitle = title
  },
  
  // progress bar
  showProgBar: function(state) {
    state.progressBar = true
  },
  hideProgBar: function(state) {
    state.progressBar = false
  },

  // alert
  showAlert: function(state) {
    state.alertBox = true
  },
  hideAlert: function(state) {
    state.alertBox = false
  },
  setAlertMsg: function(state, msg) {
    state.alertMessage = msg
  },
  setAlertCol: function(state, col) {
    state.alertColor = col
  },

  // login
  setAuth: function(state, user) {
    state.auth.isLogin = true
    state.auth.userInfo = user
  },
  clearAuth: function(state) {
    state.auth.isLogin = false
    state.auth.userInfo = {}
  },
  setToken: function(state, token) {
    state.auth.token = token
  },
  clearToken: function(state) {
    state.auth.token = ''
  },
  setUserHome: function(state, path) {
    state.auth.userHome = path
  },
  clearUserHome: function(state) {
    state.auth.userHome = ''
  },

  // nav - drawer - footer
  setDrawerColor: function(state, color) {
    state.drawerColor = color
  },
  setDrawerContent: function(state, content) {
    state.drawerContent = content
  },
  klikDrawer: function(state) {
    state.drawer = !state.drawer
  },
  closeDrawer: function(state) {
    state.drawer = false
  },

  // rules
  setRules: function(state, par) {
    const param = state.rules.find(el => el.key === par.key)
    param.value = par.value
  },
}

export default mutations